<template>
    <div class="mt-5">
        <div class="title text-center">{{ chartOptions.title.text }}</div>
        <div class="subtitle-1 text-center">{{ chartOptions.subtitle.text }}</div>
        <v-card style="margin: 10px 0 0 0;">
            <v-simple-table light>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <template v-for="(header, index) in chartOptions.data.columns[0]">
                            <td :key="index"
                                class="text-center font-weight-bold"
                                style="background-color: lightgray; border-top-right-radius: 5px;"
                                :style="{ 'border-top-left-radius': index === 0 ? '5px' : '',
                                          'border-top-right-radius': index === chartOptions.data.columns[0].length - 1 ? '5px' : '' }"
                            >
                                {{ header }}
                            </td>
                        </template>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(row, rowIndex) in chartOptions.data.columns">
                        <tr :key="rowIndex" v-if="rowIndex > 0">
                            <td v-for="(col, colIndex) in row"
                                :class="{ 'text-center': colIndex > 0, 'font-weight-bold': colIndex === 0 }"
                                :key="colIndex"
                            >
                                {{ colIndex === 0 ? col : col ? parseFloat(col).toFixed(2) : '' }}
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
    </div>
</template>

<script>
    export default {
        name: "TableRenderer",
        props: {
            chartOptions: {
                type: Object
            }
        },
        data: () => ({
            headers: null,
        })
    }
</script>

<style scoped>

</style>
